module.exports = __webpack_public_path__ + "img/bibb-schools-logo.54d6f4af.jpg";